export default "__VITE_ASSET__Chp0JcTt__"